import { CRMCHLink } from 'pco-product-service-internal-consumer';
import { crmchLinkApi } from 'api';

export const getCRMCHDirectLODLink = async (brUid: string): Promise<CRMCHLink> => {
  return await crmchLinkApi.getCRMCHDirectLODLink({ brUUID: brUid });
};
